import { render, staticRenderFns } from "./StyleFormats.vue?vue&type=template&id=ecec4050&scoped=true&"
import script from "./StyleFormats.vue?vue&type=script&lang=js&"
export * from "./StyleFormats.vue?vue&type=script&lang=js&"
import style0 from "./StyleFormats.vue?vue&type=style&index=0&id=ecec4050&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecec4050",
  null
  
)

export default component.exports